shopDataLayer = {
	header: {
		// search: {
		// 	placeholder: 'Hledat produkt',
		// 	buttonText: 'Hledej',
		// },
		// contact: {
		// 	call: {
		// 		image: '',
		// 		title: '',
		// 		number: '',
		// 	},
		// 	write: {
		// 		image: '',
		// 		title: '',
		// 		mail: '',
		// 	},
		// },
	},
	footer: {
		// newsletter: {
		// 	title: '',
		// 	subtitle: '',
		// 	placeholder: '',
		// 	buttonText: '',
		// },
		// navigation: {
		// 	more: 'Zobrazit další stránky',
		// },
		// categories: {
		// 	more: 'Zobrazit další kategorie',
		// },
		// signature: "Vytvořili <a href='https://www.webotvurci.cz/' target='_blank'>Webotvůrci</a> na platformě <a href='https://www.shoptetpremium.cz/' target='_blank'>Shoptet Premium</a>",
	},
	productDetail: {
		// parametersTop: [],
		// availabilityLabel: '',
		// buttonText: 'Koupit',
		// emptyDescription: '',
		// parametersTitle: '',
		// descriptionTitle: '',
		// hiddenParameters: [],
	},
	references: {
		title: "Recenze od našich zákazníků",
		link: "/hodnoceni-obchodu",
		textAll: "Další recenze",
		textWrite: "Napsat recenzi",
	},
};
